export default {
    created() {
        Event.$on('editorChanged', (props) => {
            this[props.prop] = props.value;
        });
    },
};



// WEBPACK FOOTER //
// ./resources/js/admin-panel/components/admin/mixins.js